var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmega3Supplement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#B9CFC0;}\n\t.st2{fill:#F8EEE1;}\n\t.st3{fill:#AA1A18;}\n\t.st4{fill:#F4A38A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.19,184.66c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.89,150.37,62.5,184.66,105.19,184.66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.55,129.68c-6.54-24.8-23.69-28.23-49.17-25.69c-26.74,2.67-29.61-10.72-29.72-11.3 c-0.1-0.5,0.03-1.02,0.35-1.42c3.72-4.65,8.21-8.6,13.32-11.75c8.4-5.17,17.88-7.78,27.51-7.71c2.72-1.45,17.65-9.17,25.95-7.64 c0.76,0.14,1.33,0.76,1.42,1.52c0.02,0.21,0.48,4.94-3.37,12.14c8.12,4.28,14.99,10.67,19.92,18.69c5.35,8.7,7.13,21.37,7.02,30.71 c8.88,6.16,11.33,14.31,11.44,14.67c0.15,0.51,0.06,1.05-0.24,1.49c-0.21,0.3-0.5,0.52-0.84,0.64c-0.15,0.05-0.31,0.09-0.47,0.1 c-6.38,0.44-11.7-1.55-14.04-2.62c-1.78,1.87-5.96,5.69-12.06,7.66c-0.5,0.16-1.05,0.09-1.49-0.2c-0.44-0.29-0.73-0.76-0.78-1.29 C127.27,147.32,126.51,138.75,132.55,129.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.71,94.29c-0.21,0.3-0.5,0.51-0.82,0.62c-0.52,0.19-1.13,0.13-1.61-0.22c-0.78-0.56-0.96-1.65-0.4-2.43 c2.45-3.41-0.23-8.75-0.27-8.83c-0.44-0.85-0.11-1.91,0.75-2.35c0.86-0.45,1.91-0.11,2.35,0.74C87.86,82.1,91.43,89.12,87.71,94.29 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.98,89.5c-0.43,0.16-0.92,0.14-1.34-0.05c-0.41-0.19-0.74-0.56-0.9-0.99c-0.15-0.43-0.14-0.92,0.06-1.33 c0.05-0.1,0.11-0.21,0.18-0.3c0.06-0.09,0.14-0.17,0.23-0.25c0.08-0.08,0.18-0.15,0.28-0.21c0.49-0.3,1.13-0.32,1.64-0.08 c0.41,0.19,0.75,0.55,0.9,0.98c0.16,0.43,0.13,0.93-0.06,1.34C76.77,89.02,76.41,89.34,75.98,89.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.29,100.11c2.02,3.53,2.41,7.52,1.42,11.15c-0.99,3.63-3.37,6.88-6.89,8.89l-36.73,21 c-0.61,0.35-1.24,0.65-1.89,0.9l14.28-8.17c3.53-2.02,5.9-5.26,6.89-8.89c0.98-3.62,0.59-7.63-1.42-11.15 c-3.67-6.42-11.46-9.03-18.15-6.37l22.43-12.83C122.29,90.62,131.27,93.07,135.29,100.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.96,113.84c2.01,3.52,2.4,7.52,1.42,11.15c-0.99,3.63-3.36,6.87-6.89,8.89l-14.28,8.17 c-6.68,2.66-14.47,0.07-18.15-6.36c-2.02-3.53-2.41-7.53-1.42-11.15c0.99-3.62,3.37-6.88,6.89-8.89l14.29-8.17 C99.5,104.82,107.29,107.42,110.96,113.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmega3Supplement);
export default __webpack_public_path__ + "static/media/Omega_3_supplement.7622bb01d75b2d933f264d57bfa5da3d.svg";
export { ForwardRef as ReactComponent };